import { render, staticRenderFns } from "./PartnersComponent.vue?vue&type=template&id=b802b7e6&"
import script from "./PartnersComponent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PartnersComponent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports